import type { EIP6963ProviderDetail } from '../../eip6963.types';
import { isEip6963Event } from '../isEip6963Event';

/** @not-instrumented */
// eslint-disable-next-line custom-rules/require-single-object-param
export const listenForEIP6963ProviderAnnouncement = (
  onProvider: (providerDetail: EIP6963ProviderDetail) => void,
  /**
   * This feature is only available in the browser
   * so it is fine to use the window directly here.
   *
   * TODO: check with others
   */
  // eslint-disable-next-line no-restricted-globals
  globalWindow = window
): VoidFunction => {
  const handler = (event: Event) => {
    if (!isEip6963Event(event)) return;

    onProvider(event.detail);
  };

  globalWindow.addEventListener('eip6963:announceProvider', handler);

  globalWindow.dispatchEvent(new Event('eip6963:requestProvider'));

  return () => {
    globalWindow.removeEventListener('eip6963:announceProvider', handler);
  };
};
